import {
  GET_PROGRESS_REPORT,
  GET_FINANCIAL_REPORT,
  GET_RESOURCE_REPORT,
  GET_MATERIAL_REPORT,
  GET_SCHEDULE_REPORT,
  GET_OVERALL_ANALYTICS,
  GET_PROFITABILITY_REPORT,
  SET_REPORT_LOADING,
  SET_REPORT_ERROR
} from '../actions/constructionReportActions';

const initialState = {
  progressReport: null,
  financialReport: null,
  resourceReport: null,
  materialReport: null,
  scheduleReport: null,
  overallAnalytics: null,
  profitabilityReport: null,
  loading: {},
  errors: {}
};

const constructionReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REPORT_LOADING:
      return { ...state, loading: { ...state.loading, [action.payload]: true } };
    case SET_REPORT_ERROR:
      return {
        ...state,
        loading: { ...state.loading, [action.payload.report]: false },
        errors: { ...state.errors, [action.payload.report]: action.payload.error }
      };
    case GET_PROGRESS_REPORT:
      return { ...state, progressReport: action.payload, loading: { ...state.loading, progress: false } };
    case GET_FINANCIAL_REPORT:
      return { ...state, financialReport: action.payload, loading: { ...state.loading, financial: false } };
    case GET_RESOURCE_REPORT:
      return { ...state, resourceReport: action.payload, loading: { ...state.loading, resource: false } };
    case GET_MATERIAL_REPORT:
      return { ...state, materialReport: action.payload, loading: { ...state.loading, material: false } };
    case GET_SCHEDULE_REPORT:
      return { ...state, scheduleReport: action.payload, loading: { ...state.loading, schedule: false } };
    case GET_OVERALL_ANALYTICS:
      return { ...state, overallAnalytics: action.payload, loading: { ...state.loading, analytics: false } };
    case GET_PROFITABILITY_REPORT:
      return { ...state, profitabilityReport: action.payload, loading: { ...state.loading, profitability: false } };
    default:
      return state;
  }
};

export default constructionReportReducer;
